module.exports = __webpack_public_path__ + "static/media/facebook-icon.cacd7f2b.png";